// prettier-ignore
export default {
    "admin_barcode": "/staff/barcode/",
    "upload_s3": "/api/storage/uploader/s3/",
    "imposition_prepress": "/layout/prepress/json/",
    "imposition_prepress_blank": "/layout/prepress_blank/json/",
    "upload_outfolders": "/api/storage/switch-outfolders/",
    "autocomplete": "/autocomplete/${name}/?v=2026.0217.0846",
    "notify_frontend_error": "/api/frontend-errors/"
} as const